<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :loading="loading"
    :server-items-length="serverItemsLength"
    :options="options"
    @update:options="$emit('update:options', $event)"
  >
    <template v-for="(_, slotName) in $scopedSlots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps" />
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    headers: { type: Array, required: true },
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },

    // -1 = client-side paging (the full items array is already in memory - Examination/Homework).
    // >= 0 = server-side paging, paired with :options.sync driving a PageResponse-backed fetch.
    serverItemsLength: { type: Number, default: -1 },
    options: { type: Object, default: () => ({ page: 1, itemsPerPage: 20 }) },
  },
}
</script>
